import { useState } from 'react';
import { useCardActionSections } from '../../hooks/useCardSections';
import { Flex } from 'foundations-components/components/Flex';
import { QuickActionsContext } from './QuickActionsContext';
import styled from 'styled-components';
import { ExpandActionButton } from '../../sections/components/ExpandActionButton';
import { View } from 'foundations-components/transitional/components/View';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { ANIMATION_DURATION_MS, ANIMATION_DELAY_MS } from '../../utils/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ActionsContainer = styled.div.withConfig({
  displayName: "CardQuickActions__ActionsContainer",
  componentId: "iz000k-0"
})(["height:0;overflow:hidden;transition:height ", " ease-in-out ", ";", ""], ANIMATION_DURATION_MS, ANIMATION_DELAY_MS, ({
  isActive
}) => isActive && `height: auto !important;`);
export const CardQuickActions = () => {
  const cardActionSections = useCardActionSections();
  const [isActive, setIsActive] = useState(false);
  const actions = cardActionSections.map(section => {
    const {
      sectionKey,
      Component
    } = section;
    return /*#__PURE__*/_jsx(Component, {}, sectionKey);
  });

  //@bend-expect trellis-tokenized
  //@bend-expect trellis-tokenized

  return /*#__PURE__*/_jsx(QuickActionsContext.Provider, {
    value: {
      isActive,
      setIsActive
    },
    children: /*#__PURE__*/_jsx(ActionsContainer, {
      className: "actions-container",
      "data-testid": "board-card-quick-actions-container",
      isActive: isActive,
      children: /*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Flex, {
          flexDirection: "row",
          justifyContent: "end",
          alignItems: "center",
          children: /*#__PURE__*/_jsx(ButtonGroup, {
            children: actions
          })
        }), /*#__PURE__*/_jsx(View, {
          children: /*#__PURE__*/_jsx(ExpandActionButton, {})
        })]
      })
    })
  });
};